import React from "react";

// Parse and embed YouTube, TikTok, Instagram links so users stay on site.

const ytId = (url) => {
  if (!url) return null;
  const m = url.match(/(?:youtu\.be\/|v=|\/embed\/|\/shorts\/)([A-Za-z0-9_-]{6,})/);
  return m ? m[1] : null;
};

const vimeoId = (url) => {
  if (!url) return null;
  const m = url.match(/(?:player\.)?vimeo\.com\/(?:[\w-]+\/)*(\d+)/);
  return m ? m[1] : null;
};

const tiktokId = (url) => {
  if (!url) return null;
  const m = url.match(/video\/(\d+)/);
  return m ? m[1] : null;
};

const igCode = (url) => {
  if (!url) return null;
  const m = url.match(/instagram\.com\/(?:p|reel|tv)\/([A-Za-z0-9_-]+)/);
  return m ? m[1] : null;
};

const scUrl = (url) => (url && /soundcloud\.com\//.test(url) ? url : null);

const Frame = ({ children, label }) => (
  <div
    data-testid={`embed-${label}`}
    className="relative rounded-xl overflow-hidden border border-[#2D3748] bg-[#0B0D12]"
  >
    {children}
  </div>
);

export const SocialEmbeds = ({ links }) => {
  if (!links) return null;
  const yt = ytId(links.youtube);
  const vm = vimeoId(links.vimeo);
  const tt = tiktokId(links.tiktok);
  const ig = igCode(links.instagram);
  const sc = scUrl(links.soundcloud);
  if (!yt && !vm && !tt && !ig && !sc) return null;

  return (
    <div data-testid="social-embeds" className="grid grid-cols-1 md:grid-cols-2 gap-5 my-8">
      {yt && (
        <Frame label="youtube">
          <div className="aspect-video w-full">
            <iframe
              className="w-full h-full"
              src={`https://www.youtube.com/embed/${yt}`}
              title="YouTube video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </Frame>
      )}
      {vm && (
        <Frame label="vimeo">
          <div className="aspect-video w-full">
            <iframe
              className="w-full h-full"
              src={`https://player.vimeo.com/video/${vm}`}
              title="Vimeo video"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            />
          </div>
        </Frame>
      )}
      {tt && (
        <Frame label="tiktok">
          <iframe
            className="w-full"
            style={{ height: 640, border: "none" }}
            src={`https://www.tiktok.com/embed/v2/${tt}`}
            title="TikTok video"
            allow="autoplay; encrypted-media; fullscreen"
          />
        </Frame>
      )}
      {ig && (
        <Frame label="instagram">
          <iframe
            className="w-full bg-white"
            style={{ height: 640, border: "none" }}
            src={`https://www.instagram.com/p/${ig}/embed`}
            title="Instagram post"
            allowTransparency="true"
            allow="encrypted-media"
          />
        </Frame>
      )}
      {sc && (
        <div className="md:col-span-2">
          <Frame label="soundcloud">
            <iframe
              className="w-full"
              style={{ height: 450, border: "none" }}
              scrolling="no"
              allow="autoplay"
              src={`https://w.soundcloud.com/player/?url=${encodeURIComponent(sc)}&color=%238B5CF6&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=true&visual=true`}
              title="SoundCloud player"
            />
          </Frame>
        </div>
      )}
    </div>
  );
};
